import React, { FC } from 'react';
import { Logout } from '@mui/icons-material';
import { AppBar, Toolbar } from '@material-ui/core';
import { Box, Typography, IconButton, Avatar } from '@mui/material';

import { useAuth } from '../../../hooks/useAuth';

interface Props {
  userName: string | undefined;
}

const Header: FC<Props> = ({ userName }) => {
  const { logout } = useAuth();

  const stringAvatar = (name: string) => {
    return {
      sx: {
        bgcolor: '#1F6CFA',
      },
      children: `${name.split(' ')[0][0]}`,
    };
  };

  return (
    <AppBar
      elevation={1}
      color="default"
      position="sticky"
      style={{ height: 100, background: '#2A3453', marginBottom: 20 }}
    >
      <Toolbar
        style={{
          marginTop: 15,
          display: 'flex',
          marginRight: 25,
          alignContent: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Typography fontSize="1em" textTransform="none" color="white" marginRight={1}>
          {userName}
        </Typography>
        <Box mr={10}>
          <Avatar {...stringAvatar(userName || '')} />
        </Box>
        <IconButton onClick={logout} edge="start">
          <Logout style={{ fontSize: '30px', color: '#ffffff', marginRight: 3 }} />
        </IconButton>
        <Typography fontSize="1em" color="#fff" textTransform="none">
          Выйти
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
